/**
 * Envelope de erro da API — o mesmo nos seis servicos.
 *
 * `{"erro": {"codigo": "...", "mensagem": "..."}}`, com mensagem em PT-BR pronta para
 * ser exibida ao usuario.
 */

export interface EnvelopeDeErro {
  erro: {
    codigo: string
    mensagem: string
  }
}

/** Mensagem exibida quando a resposta nao trouxe envelope algum (rede caiu, 502 do gateway). */
export const MENSAGEM_DE_ERRO_DESCONHECIDO = 'Nao foi possivel completar a operacao. Tente novamente.'

export function ehEnvelopeDeErro(valor: unknown): valor is EnvelopeDeErro {
  if (typeof valor !== 'object' || valor === null || !('erro' in valor)) {
    return false
  }
  const { erro } = valor
  return (
    typeof erro === 'object' &&
    erro !== null &&
    typeof (erro as { codigo?: unknown }).codigo === 'string' &&
    typeof (erro as { mensagem?: unknown }).mensagem === 'string'
  )
}

/**
 * Erro de uma chamada a API, ja com o codigo e a mensagem em PT-BR do envelope.
 *
 * `extras` e o que o envelope trouxe **alem** de `codigo` e `mensagem` — desde a 13.6, so o `409` de
 * apagar etiqueta em uso, com `uso: {empresas, pessoas}`. A tela le os numeros dali para decidir os
 * botoes, e mostra a mensagem como veio: o SPA nunca reescreve mensagem do backend.
 */
export class ErroDaApi extends Error {
  readonly status: number
  readonly codigo: string
  readonly extras: Readonly<Record<string, unknown>>

  constructor(
    status: number,
    codigo: string,
    mensagem: string,
    extras: Readonly<Record<string, unknown>> = {},
  ) {
    super(mensagem)
    this.name = 'ErroDaApi'
    this.status = status
    this.codigo = codigo
    this.extras = extras
  }
}
